export const filterSheetFieldLabelClassName =
  'text-xs font-semibold uppercase tracking-wide text-muted-foreground'

export const filterDropdownTriggerClassName =
  'filter-dropdown-trigger flex h-11 w-full items-center justify-between gap-2 rounded-lg border border-border/50 bg-muted px-3.5 py-0 text-filter-pill text-foreground shadow-none transition-colors hover:bg-muted/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 dark:border-border/50 dark:bg-secondary dark:hover:bg-secondary/80 dark:focus-visible:ring-ring/30 [&>span]:text-filter-pill [&>span]:font-normal'

export const filterDropdownValueClassName = 'truncate text-filter-pill font-normal text-foreground'

/** Expanded location city picker — same surface + radius as filter triggers, no outer padding. */
export const filterLocationPanelClassName =
  'filter-location-panel max-h-[min(280px,40vh)] overflow-hidden rounded-lg border border-border/50 bg-muted p-0 shadow-none dark:border-border/50 dark:bg-secondary'

export const filterLocationPanelSearchInputClassName =
  'h-9 border-0 bg-transparent px-3.5 py-0 text-filter-pill shadow-none placeholder:text-muted-foreground'

export const filterLocationPanelListItemClassName =
  'filter-sheet-select-item flex w-full items-center gap-2 px-3.5 py-2 text-left text-filter-pill transition-colors hover:bg-muted/70'

export const filterSheetNestedSelectContentClassName =
  'filter-sheet-select z-[130] max-h-60 overflow-hidden rounded-lg border border-border/50 bg-muted p-1 shadow-none dark:border-border/50 dark:bg-secondary'

/** Matches `gap-2` between location trigger and its panel. */
export const filterSheetSelectContentSideOffset = 8

export const filterSheetSelectItemClassName =
  'filter-sheet-select-item relative flex w-full cursor-default select-none items-center rounded-md py-2.5 pl-8 pr-3 text-filter-pill text-foreground outline-none data-[highlighted]:bg-muted/70 data-[highlighted]:text-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50'

export const filterSheetSelectItemTextClassName = 'filter-sheet-select-item-text'

export const filterSheetActionButtonClassName =
  'flex h-11 flex-1 items-center justify-center rounded-lg text-sm font-medium'

export const filterPillClassName =
  'inline-flex h-11 shrink-0 items-center gap-1.5 rounded-lg border border-transparent bg-muted/60 px-3.5 text-filter-pill text-foreground transition-colors hover:bg-muted/80 dark:bg-secondary dark:text-secondary-foreground dark:hover:bg-secondary/80'

export const filterPrimaryButtonClassName =
  'inline-flex h-11 shrink-0 items-center justify-center rounded-lg bg-primary px-3.5 text-filter-pill text-primary-foreground transition-colors hover:bg-primary/90'

export const filterSearchBarShellClassName =
  'relative flex h-11 items-center bg-background border border-border rounded-lg shadow-sm'

export const filterSearchInputClassName =
  'flex-1 min-w-0 border-none bg-transparent shadow-none outline-none focus-visible:ring-0 focus-visible:ring-offset-0 h-11 py-0 px-3.5 text-filter-pill placeholder:text-muted-foreground placeholder:font-[var(--font-weight-filter-pill)]'

export const filterSearchBarIconButtonClassName = 'h-11 w-11 shrink-0'

/** Same size/color as icons inside filter pills (inherits `text-foreground` from button surface). */
export const filterSearchBarIconClassName = 'h-4 w-4 shrink-0'

export const filterSearchBarIconButtonSurfaceClassName =
  'm-0 border-0 shrink-0 bg-muted/60 p-0 text-foreground transition-colors hover:bg-muted/80 dark:bg-secondary dark:text-secondary-foreground dark:hover:bg-secondary/80'
